import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { IconShell } from 'components/atoms/icon-shell';
import { StatusIndicator } from 'components/molecules/status-indicator';
import { MinifiedTaskModal } from 'components/organisms/templates/task-modal';
import { ProjectTemplateTask } from 'data/templates/projects';

const Container = styled(Button)<{ readOnly?: boolean }>`
  &&& {
    background: transparent;
    border: none;
    color: inherit;
    cursor: ${({ readOnly }) => `${readOnly ? 'inherit' : 'pointer'}`};
    opacity: 1;
    padding: 0;
    width: 100%;
  }
`;

export const StatusIndicatorCell: FC<{
  docId: number;
  readOnly?: boolean;
  resourceSectionId: number;
  task: ProjectTemplateTask;
  text: string;
}> = ({ docId, readOnly, resourceSectionId, task, text }) => {
  const [isModalVisible, toggleModalVisibility] = useState(false);

  return (
    <>
      <Container
        readOnly={readOnly}
        onClick={() => !readOnly ?? toggleModalVisibility(true)}
      >
        <IconShell
          icon={
            <StatusIndicator
              status={{
                color: 'blue',
                group: 1,
                label: 'To do',
              }}
            />
          }
        />
        <div>{text}</div>
      </Container>
      <MinifiedTaskModal
        docId={docId}
        resourceSectionId={resourceSectionId}
        task={task}
        visible={isModalVisible}
        onClose={() => toggleModalVisibility(false)}
      />
    </>
  );
};
